import { IApplePaySession } from "../../models/IApplePaySession";
import { IApplePayShippingContactCallbackActions } from "../../models/IApplePayShippingContactCallbackActions";
import { RequestJwtUpdateHandler } from "../../../../../application/core/services/st-codec/RequestJwtUpdateHandler";
import { APPLE_PAY_STATUS } from "../session/models/ApplePayStatus";
import { IJwtEnhancedApplePayShippingContactUpdate } from "../../models/IJwtEnhancedApplePayShippingContactUpdate";
import { ApplePayErrorUtils } from "./ApplePayErrorUtils";

export class ApplePayShippingContactResolver implements IApplePayShippingContactCallbackActions {
  constructor(
    private readonly session: IApplePaySession,
    private readonly versionNumber: number,
    private readonly jwtRequestHandler: RequestJwtUpdateHandler,
  ) {}

  public resolve(param: IJwtEnhancedApplePayShippingContactUpdate): void {
    if (this.versionNumber <= 2) {
      this.handleLegacyVersion(param);
    } else {
      this.handleCurrentVersion(param);
    }
    this.handleJwtUpdate(param);
  }

  // Handle older versions of Apple Pay
  private handleLegacyVersion(
    param: IJwtEnhancedApplePayShippingContactUpdate,
  ): void {
    const status = this.determineShippingStatus(param.errors);
    this.session.completeShippingContactSelection(
      status,
      param.newShippingMethods,
      param.newTotal,
      param.newLineItems,
    );
  }

  // Determines the shipping status based on errors
  private determineShippingStatus(
    errors: ApplePayJS.ApplePayError[] = [],
  ): number {
    return errors.length > 0
      ? APPLE_PAY_STATUS.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS
      : APPLE_PAY_STATUS.STATUS_SUCCESS;
  }

  // Handle current Apple Pay versions
  private handleCurrentVersion(
    param: IJwtEnhancedApplePayShippingContactUpdate,
  ): void {
    if (
      param.errors &&
      param.errors.length > 0 &&
      ApplePayErrorUtils.isApplePayErrorAvailable()
    ) {
      param.errors = ApplePayErrorUtils.setApplePayErrorForAppleDevice(
        param.errors,
      );
    }
    // Ensure the structure passed to completeShippingContactSelection is valid
    this.session.completeShippingContactSelection(param);
  }

  //If they provide the JWT key, allow them to call updateJWT without needing a reference to the ST object.
  private handleJwtUpdate(
    param: IJwtEnhancedApplePayShippingContactUpdate,
  ): void {
    if (param.jwt) {
      this.jwtRequestHandler.request(param.jwt);
    }
  }
}
